import React, { useState, useMemo } from 'react';
import { Container, SmartPhone, Tablet, Laptop } from './DevicePreview.styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// https://www.w3schools.com/howto/howto_css_devices.asp

const DevicePreview: React.FC = ({ children }) => {
  const [mode, setMode] = useState<'tablet' | 'phone' | 'laptop'>('tablet');

  const Component = useMemo(() => {
    switch (mode) {
      case 'phone':
        return SmartPhone;

      case 'laptop':
        return Laptop;

      default:
        return Tablet;
    }
  }, [mode]);

  return (
    <div className="d-flex justify-content-between">
      <Container>
        <Component>{children}</Component>
      </Container>
      <div className="d-flex flex-column align-items-center">
        <FontAwesomeIcon
          icon="mobile"
          size="3x"
          role="button"
          color={mode === 'phone' ? 'black' : 'lightgray'}
          onClick={() => setMode('phone')}
        />
        <FontAwesomeIcon
          className="mt-2"
          icon="tablet"
          size="3x"
          role="button"
          color={mode === 'tablet' ? 'black' : 'lightgray'}
          onClick={() => setMode('tablet')}
        />
        <FontAwesomeIcon
          className="mt-2"
          icon="laptop"
          size="3x"
          role="button"
          color={mode === 'laptop' ? 'black' : 'lightgray'}
          onClick={() => setMode('laptop')}
        />
      </div>
    </div>
  );
};

export default DevicePreview;
